import styled from 'styled-components';

export const MapWrapper = styled.div`
    position: relative;
    height: 100%;
`;
